var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visitor-visa"},[_c('h1',[_vm._v("旅游探亲签证Visitor Visa")]),_c('div',{staticClass:"subtitle"},[_vm._v("访问签证")]),_c('p',[_vm._v("是为来加拿大进行旅游探亲的外国人发放的签证，有效期最长为十年。")])])
}]

export { render, staticRenderFns }